<template>
  <div class="chart-container">
    <Bar
      :chart-data="formattedChartData"
      :options="mergedOptions"
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';
import { defineComponent, computed } from 'vue';
import { merge } from 'lodash';

export default defineComponent({
  name: 'HistogramChart',
  components: {
    Bar,
  },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    theme: {
      type: String,
      default: 'light',
    },
  },
  setup(props) {
    const defaultOptions = computed(() => ({
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          type: 'linear', // Important for histogram
          grid: {
            color: props.theme === 'dark' ? '#444' : '#ddd',
          },
          ticks: {
            color: props.theme === 'dark' ? '#fff' : '#000',
          },
        },
        y: {
          beginAtZero: true,
          grid: {
            color: props.theme === 'dark' ? '#444' : '#ddd',
          },
          ticks: {
            color: props.theme === 'dark' ? '#fff' : '#000',
          },
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          backgroundColor: props.theme === 'dark' ? '#333' : '#fff',
          titleColor: props.theme === 'dark' ? '#fff' : '#000',
          bodyColor: props.theme === 'dark' ? '#fff' : '#000',
        },
      },
    }));

    const mergedOptions = computed(() => merge(defaultOptions.value, props.options));

    const formattedChartData = computed(() => ({
      ...props.chartData,
      datasets: props.chartData.datasets.map((dataset) => ({
        ...dataset,
        backgroundColor: dataset.backgroundColor || 'rgba(75, 192, 192, 0.4)',
        borderColor: dataset.borderColor || 'rgba(75, 192, 192, 1)',
        barPercentage: 1.0,
        categoryPercentage: 1.0,
      })),
    }));

    return {
      mergedOptions,
      formattedChartData,
    };
  },
});
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
